<div *ngFor="let alert of alerts" class="{{cssClass(alert)}}" role="alert">
  <span [innerHTML]="alert.message"></span>
  <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="removeAlert(alert)">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
